export const ProductCodes = {
  PaternityDuo: "DUO",
  PaternityTrio: "TRIO",
  MaternityDuo: "MAT DUO",
  LegalPaternityDuo: "LEGAL PAT DUO",
  LegalPaternityTrio: "LEGAL PAT TRIO",
  LegalMaternityDuo: "LEGAL MAT DUO",
  LegalProduct: "LEG"
}